// Enhanced Ellucian design system colors with additional styling colors
export const ellucianColors = {
  primary: '#7100EB',      // Ellucian Iris-600 (cta-iris-600 active) brand color
  secondary: '#5A1FB8',    // Secondary purple  
  fountain: '#50E3C2',     // Fountain teal
  white: '#FFFFFF',        // White
  black: '#000000',        // Black
  lightGray: '#F8F9FA',    // Light gray for backgrounds
  mediumGray: '#E9ECEF',   // Medium gray for borders
  darkGray: '#495057',     // Dark gray for text
  deepPurple: '#4C1D95',   // Deep purple for accents
  accent: '#FF6B6B',       // Accent red for highlights
  success: '#28A745',      // Enhanced green
  warning: '#FFC107',      // Enhanced orange
  error: '#DC3545',        // Enhanced red
  gold: '#5A1FB8',         // Gold for popular content
  neutral600: '#151618',   // Neutral dark for text
  neutral500: '#5B5E65',
  interactiveBlue:'#026BC8',
  neutral300:'#D9D9D9'
} as const;
